
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "10px",
    "height": "10px",
    "viewBox": "0 0 10 10",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "icon-caret-right-white"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "icon-caret-right-white",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "caret-right",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形",
                "fill": "#000000",
                "opacity": "0",
                "x": "0",
                "y": "0",
                "width": "10",
                "height": "10"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M7.70404722,4.77312932 L3.39596357,1.0578597 C3.23531549,0.919838117 3,1.04428381 3,1.26715473 L3,8.69769397 C3,8.9205649 3.23531549,9.04501059 3.39596357,8.90698901 L7.70404722,5.19171939 C7.82736159,5.08537488 7.82736159,4.87947383 7.70404722,4.77312932 Z",
                "id": "路径",
                "fill": "#FFFFFF"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  